import { WebsiteThemeInterface } from 'src/editor/store/website-settings/website-settings-types'
import { dropdownGroupTitlesLocoKeys } from 'src/editor/website/styles/themes/website-theme-dropdown/consts'
import {
  WebsiteDropdownGroupTitles,
  WebsiteDropdownTitles,
} from '../../website-theme-dropdown/types'

export const pickThemeGroups = (
  theme: WebsiteThemeInterface,
): Omit<WebsiteThemeInterface, 'id' | 'isCommon' | 'name'> => {
  return (
    Object.keys(dropdownGroupTitlesLocoKeys) as WebsiteDropdownGroupTitles[]
  ).reduce(
    (acc, key) => {
      acc[key] = theme[key] as WebsiteDropdownTitles
      return acc
    },
    {} as Partial<Omit<WebsiteThemeInterface, 'id' | 'isCommon' | 'name'>>,
  ) as Omit<WebsiteThemeInterface, 'id' | 'isCommon' | 'name'>
}
